module.exports = __webpack_public_path__ + "static/img/29.9cea4c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/29.png
// module id = 5qIH
// module chunks = 1